import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'treeApp';
  isMobile: boolean = false;
  router: string;
  url: string;
  constructor(private location: Location) {
    this.url = location.path()
  }
  ngOnInit() {
    if (window.screen.width < 700) {
      this.isMobile = true;
    }
  }
}
